import React from 'react';
import AbsencesPage from '../../../components/absence/ManageAbsencesMobile/ManageAbsencesMobile';

const AbsenceRequest = () => {
    return (
            <AbsencesPage />
    );
};

export default AbsenceRequest;